import axios, { AxiosRequestConfig, AxiosTransformer } from 'axios'
import { camelize } from '../../../utils/camelize'

/**
 * Перехватчик на выполнение запроса
 * @param {*} config
 */
export function RequestInterceptor(config: AxiosRequestConfig & { camelize?: boolean }): AxiosRequestConfig {
  const convert = typeof config.camelize === 'boolean' ? config.camelize : true

  if (config.headers) config.headers['Content-Type'] = 'application/json'
  else config.headers = { 'Content-Type': 'application/json' }

  config.headers['X-Referer'] = window?.location?.href || ''
  config.headers['Referrer-Policy'] = 'no-referrer-when-downgrade'

  if (convert) {
    const defaultTransform: AxiosTransformer | AxiosTransformer[] = axios.defaults.transformResponse || []

    const camelizeResponse: AxiosTransformer = (data: typeof config.data): typeof config.data => {
      return camelize(data)
    }

    const transformers: AxiosTransformer[] = Array.isArray(defaultTransform)
      ? [...defaultTransform, camelizeResponse]
      : [defaultTransform, camelizeResponse]

    config.transformResponse = transformers
  }

  return config
}
